export default __webpack_public_path__ + "static/media/ep3collage6.7e7f2adf.jpg";